export default {
  getUrlQuery: (name) => {
    var tstr = window.location.href
    let index = tstr.indexOf('?')
    let query = tstr.substring(index + 1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == name) {
        return pair[1];
      }
    }

    return (false);
  },
  isWXClient() {
    if (/MicroMessenger/i.test(navigator.userAgent)) {
      return true;
    } else {
      return false;
    }
  },
  saveLocalStorage(item, storageData) {
    try {
      localStorage.setItem('site:' + item, JSON.stringify(storageData));
    } catch (e) {
      // eslint-disable-next-line
      console.log("not support savelocalstorage");
    }
  },
  getLocalStorage(item) {
    try {
      return JSON.parse(localStorage.getItem('site:' + item));
    } catch (error) {
      // eslint-disable-next-line
      console.log("not support getlocalstorage");
    }
  },
  removeLocalStorage(item) {
    try {
      localStorage.removeItem('site:' + item);
    } catch (error) {
      // eslint-disable-next-line
      console.log("not support removelocalstorage");
    }
  }
}